var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.1001C16.8302 1.1001 21.5 5.50253 21.5 10.854C21.4999 13.0393 20.8386 15.4615 19.8203 17.8872C18.804 20.3082 17.4444 22.7026 16.0791 24.8237C14.7146 26.9436 13.3497 28.7826 12.3252 30.0913C11.8131 30.7454 11.3867 31.2666 11.0889 31.6235C11.0581 31.6604 11.0279 31.6947 11 31.728C10.9721 31.6947 10.9419 31.6604 10.9111 31.6235C10.6133 31.2666 10.1869 30.7454 9.6748 30.0913C8.65027 28.7826 7.28542 26.9436 5.9209 24.8237C4.55556 22.7026 3.19601 20.3082 2.17969 17.8872C1.16145 15.4615 0.500067 13.0393 0.5 10.854C0.5 5.50253 5.1698 1.1001 11 1.1001ZM12.8809 7.32275C11.9835 6.93783 10.9949 6.83724 10.041 7.03369C9.08717 7.2302 8.21335 7.71489 7.5293 8.42334C6.84547 9.13158 6.38116 10.0317 6.19336 11.0093C6.00562 11.9868 6.10206 13.0005 6.4707 13.9224C6.83938 14.8442 7.46478 15.6351 8.27051 16.1929C9.07669 16.7508 10.0269 17.0503 11 17.0503H11.001C12.3056 17.0487 13.5528 16.5107 14.4697 15.561C15.3861 14.6119 15.8989 13.3286 15.9004 11.9937V11.9927C15.9003 10.9964 15.6152 10.021 15.0791 9.18994C14.5428 8.35864 13.7782 7.7077 12.8809 7.32275Z",
    fill: "#D52F3D",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 12.1501,
    r: 6.05,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.8125L13.7124 15.2749",
    stroke: "#D52F3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7124 9.8125L8.25 15.2749",
    stroke: "#D52F3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon5);
export default __webpack_public_path__ + "static/media/OutletIcon5.3ab08ece9563b36750e20f2af632d8e6.svg";
export { ForwardRef as ReactComponent };